import React from 'react';
import { GRIBBLE_CONTRACT_ADDRESS } from 'utils/contract';
import { nftMarketplaceUrl } from 'utils/socials';
import { ShareDropdownButton } from '../ShareDropdownButton';
import { GenericSharing } from './Generic';

export function GribbleShareDropdown({ gribble, text, align }: GribbleShareDropdownProps) {
  const openSeaLink = nftMarketplaceUrl.openSea({
    contract: GRIBBLE_CONTRACT_ADDRESS,
    nftId: Number(gribble.id),
  });

  const fallback = {
    text: `Check out this character from the #DuskBreakers Gallery: ${openSeaLink.toString()}`,
    link: openSeaLink,
  };

  return (
    <ShareDropdownButton data={fallback} text={text}>
      <GenericSharing
        openSeaLink={openSeaLink}
        data={{
          twitter: {
            text: `Check out my #DuskBreakers Gribble on OpenSea by @duskbreakers: ${openSeaLink.toString()}`,
            link: openSeaLink,
          },
          telegram: {
            text: `Check out my #DuskBreakers Gribble on OpenSea:`,
            link: openSeaLink,
          },
          fallback,
        }}
        align={align}
      />
    </ShareDropdownButton>
  );
}

export type GribbleShareDropdownProps = {
  gribble: { id: number };
  text?: string;
  align?: 'left' | 'right';
};
